<!--
 * @Author: YuanYuan
 * @Date: 2024-02-04 16:41:31
 * @LastEditTime: 2025-11-24 16:27:51
 * @description: 典型页面（全量页面包含：1.搜索区域，2.内容区域）
-->
<template>
  <div class="container-page">
    <!-- 面包屑右侧内容 -->
    <div class="container-page_breadcrum-action">
      <slot name="breadcrum-action"></slot>
    </div>
    <div v-if="search" class="container-page_search">
      <slot name="search"></slot>
    </div>
    <div class="px-16 py-16">
      <div class="common-module-block px-16 pt-16" :style="{'padding-bottom': pbGap + 'px'}">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { toRefs } from 'vue'

const props = defineProps({
  search: {
    type: Boolean,
    default: false
  },
  // 当结尾元素是表单或分页器时，padding-bottom就是表单el-form-item元素本身的下边距，否则设置为 16
  pbGap: {
    type: Number,
    default: 0
  }
})

const { search, pbGap } = toRefs(props)
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/top-search.scss';
$breadcrumH: 50px;
.container-page{
  position: relative;
  &_breadcrum-action{
    position: absolute;
    top: calc(0px - $breadcrumH);
    height: $breadcrumH;
    right: 0;
    padding: 0 16px;
  }
  &_search{
    @include top-search()
  }
}
</style>
